import { defineMessages } from 'react-intl';

export const messages = defineMessages({
    NITG_CODE_MISSING: {
        id: 'ase.issueStated.option.NITGCodeMissing',
        defaultMessage: 'NITG code missing'
    },
    SYMPTOME_CODE_MISSING: {
        id: 'ase.issueStated.option.SymptomeCodeMissing',
        defaultMessage: 'Symptom code missing'
    },
    DTC_MISSING: {
        id: 'ase.issueStated.option.DTCMissing',
        defaultMessage: 'DTC missing'
    },
    APPLICABILITY_MISSING: {
        id: 'ase.issueStated.option.ApplicabilityMissing',
        defaultMessage: 'Applicability missing (project/TAPV/application date)'
    },
    TM_MISSING: {
        id: 'ase.issueStated.option.TMMissing',
        defaultMessage: 'TM is missing'
    },
    ACTION_TO_APPLY_NOT_CLEAR: {
        id: 'ase.issueStated.option.ActionToApplyNotClear',
        defaultMessage: 'Action to apply is not clear'
    },
    WRITING_QUALITY_NOT_RESPECTED: {
        id: 'ase.issueStated.option.WritingQualityNotRespected',
        defaultMessage: 'Writing quality is not respected'
    },
});

export default messages;
